import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@material-ui/core";
import { useStyles } from "../styled";
import { Skeleton } from "@material-ui/lab";

export default function DashboardSecuritySettingsLoader() {
  const classes = useStyles();

  return (
    <Paper
      className={classes.container}
      data-testid={"security-options_loading"}
    >
      <Box>
        <Skeleton variant="text" width="30%" height={32} />
        <Box mt={1}>
          <Skeleton variant="text" width="70%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Box>

      <List>
        {[1, 2, 3, 4, 5].map((item, index) => (
          <Box key={`skeleton-item-${item}`}>
            <ListItem disableGutters>
              <ListItemIcon>
                <Skeleton
                  variant="rect"
                  width={38}
                  height={24}
                  style={{ borderRadius: 12 }}
                />
              </ListItemIcon>
              <ListItemText
                primary={<Skeleton variant="text" width="40%" height={24} />}
                secondary={<Skeleton variant="text" width="60%" height={20} />}
              />
            </ListItem>
            {index < 4 && <Divider variant="middle" />}
          </Box>
        ))}
      </List>

      <Skeleton
        variant="rect"
        width={120}
        height={36}
        style={{ marginTop: 10, borderRadius: 4 }}
      />
    </Paper>
  );
}
